import React from 'react';
import PortalOverlay, { PortalOverlayModal } from '../../../ui/PortalOverlay';
import { ApptCancelModalContent, ApptCancelModalContentProps } from './ApptCancelModalContent';

export type ApptCancelModalProps = {
  id: string;
} & ApptCancelModalContentProps;

export const ApptCancelModal: React.FC<ApptCancelModalProps> = (props: ApptCancelModalProps) => (
  <PortalOverlay name="appointment-cancellation-modal-backdrop">
    <PortalOverlayModal position="growDialog" testID={`${props.id} | dialog`}>
      <ApptCancelModalContent {...props} />
    </PortalOverlayModal>
  </PortalOverlay>
);

ApptCancelModal.defaultProps = {};
